import React, { Fragment, useState } from 'react';
import Breadcrumb from '../common/breadcrumb';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import Footer from './footer'
import TablaBanners from './banners/tabla_banners';

const LosPrimos = () => {

    const [activeTab2, setActiveTab2] = useState('1');
    return (
        <Fragment>
            
            <Breadcrumb parent="Inicio" title="Banners" />

            <div className="dash-content-wrap">
                <div className="dash-content">
                    <div className="card">
                        <div className="card-header">
                            <h5>Banners</h5>
                        </div>
                        <div className="card-body">
                            <Nav tabs className="border-tab-primary">
                                <NavItem className="nav nav-tabs" id="myTab" role="tablist">
                                    <NavLink className={activeTab2 == '1' ? 'active' : ''} onClick={() => setActiveTab2('1')}>
                                        <i className="fa fa-image"></i> Banners
                                    </NavLink>
                                </NavItem>
                             {/*    <NavItem className="nav nav-tabs" id="myTab" role="tablist">
                                    <NavLink className={activeTab2 == '2' ? 'active' : ''} onClick={() => setActiveTab2('2')}>
                                        <i className="fa fa-list-ul"></i> Footer
                                    </NavLink>
                                </NavItem> */}
                                {/* <NavItem className="nav nav-tabs" id="myTab" role="tablist">
                                    <NavLink className={activeTab2 == '3' ? 'active' : ''} onClick={() => setActiveTab2('3')}>
                                        <i className="icofont icofont-contacts"></i> Contact
                                    </NavLink>
                                </NavItem> */}
                            </Nav>
                            <TabContent activeTab={activeTab2}>
                                <TabPane tabId="1">
                                    <TablaBanners/>
                                </TabPane>
                                <TabPane tabId="2">
                                    <Footer/>
                                </TabPane>
                                <TabPane tabId="3">
                                    <p className="mb-0 m-t-30">Lorem Ipsum is simply dummy text of the printing and typesetting industry. when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum</p>
                                </TabPane>
                            </TabContent>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default LosPrimos;
